import { Link } from "react-router-dom";
import { MapPin, BadgeCheck } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { initials } from "@/lib/format";

export function CoachCard({ coach }) {
  const professions = coach.professions?.length ? coach.professions : coach.profession ? [coach.profession] : [];
  return (
    <Link
      to={`/coaches/${coach.id}`}
      data-testid={`coach-card-${coach.id}`}
      className="group flex flex-col overflow-hidden rounded-2xl border border-border bg-card transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_18px_40px_-24px_rgba(44,44,42,0.45)]"
    >
      <div className="relative h-28 bg-accent">
        {coach.header_image ? (
          <img src={coach.header_image} alt="" loading="lazy" className="h-full w-full object-cover" />
        ) : (
          <div className="h-full w-full bg-gradient-to-br from-sage-pale to-oat-200" />
        )}
        <Avatar className="absolute -bottom-7 left-5 h-16 w-16 border-4 border-card shadow-sm">
          <AvatarImage src={coach.photo} alt={coach.name} />
          <AvatarFallback className="bg-primary text-base text-primary-foreground">
            {initials(coach.name)}
          </AvatarFallback>
        </Avatar>
      </div>

      <div className="flex flex-1 flex-col gap-2 px-5 pb-5 pt-10">
        <div className="flex items-center gap-1.5">
          <h3 className="font-display text-lg text-foreground">{coach.name}</h3>
          {coach.verified ? <BadgeCheck className="h-4 w-4 text-primary" /> : null}
        </div>
        {professions.length ? (
          <p className="text-sm text-muted-foreground">{professions.slice(0, 2).join(" · ")}</p>
        ) : null}
        {coach.bio ? (
          <p className="line-clamp-2 flex-1 text-sm text-muted-foreground">{coach.bio}</p>
        ) : null}

        <div className="mt-2 flex flex-wrap items-center gap-2">
          {(coach.expertise || []).slice(0, 3).map((e) => (
            <Badge key={e} variant="secondary" className="rounded-full font-normal">
              {e}
            </Badge>
          ))}
        </div>

        {(coach.region || coach.location) && (
          <div className="mt-1 inline-flex items-center gap-1 text-xs text-muted-foreground">
            <MapPin className="h-3.5 w-3.5" /> {coach.location || coach.region}
          </div>
        )}
      </div>
    </Link>
  );
}
